import { Dayjs } from 'dayjs'
import { CSSProperties } from 'react'

export interface NotificationFileInfo {
  notificationFileId: string
  filename: string
}

export interface Notification {
  id: string
  title: string
  content: string
  shiftType: number
  contentType: ContentType
  status: number
  sentAt: Dayjs
  notificationFiles: NotificationFileInfo[]
}

export const notificationStatus = {
  Notifying: 10, // 通知中
  NotifyFailure: 20, // 通知失敗
  Notified: 30, // 通知済み
  AlreadyRead: 40, // 既読
}

export const contentType = {
  AssignConfirmation: 1, // 配置の可否確認
  AssignSuspension: 2, // 配置の中止案内
  AssignNotification: 10, // 配置に関するお知らせ
  Announcement: 20, // 社内報
  SecurityReport: 30, // 警備報告書
  ThoughtfulInterviewsVER_1: 100, // システム通知[警備員の思考性アンケートver1]
  SecurityInsight: 200, //  システム通知[kumocan -> 警備員に送る検証用の質問]
  SecuriryOnboarding_V1: 300, // 警備員の入社時アンケート
} as const
export type ContentType = (typeof contentType)[keyof typeof contentType]

export const BADGE_TYPE = {
  DAY: 1, // 日勤
  NIGHT: 2, // 夜勤
  CROWD: 3, // 雑踏
}

// 既存のバッジ取得関数はそのまま利用
export const BADGE_TYPE_OPTIONS: { label: string; value: number }[] = [
  { label: '日勤', value: BADGE_TYPE.DAY },
  { label: '夜勤', value: BADGE_TYPE.NIGHT },
  { label: '雑踏', value: BADGE_TYPE.CROWD },
]

export const getBadgeLabel = (shiftType: number): string => {
  const option = BADGE_TYPE_OPTIONS.find((o) => o.value === shiftType)
  return option ? option.label : '不明'
}

// バッジタイプのスタイル取得関数
export const getBadgeStyle = (shiftType: number): CSSProperties => {
  switch (shiftType) {
    case BADGE_TYPE.DAY:
      return { backgroundColor: '#FF4800', color: 'white' } // 日勤
    case BADGE_TYPE.NIGHT:
      return { backgroundColor: 'rgb(0, 98, 140)', color: 'white' } // 夜勤
    case BADGE_TYPE.CROWD:
      return { backgroundColor: '#32a852', color: 'white' } // 雑踏
    default:
      return { backgroundColor: 'gray', color: 'white' } // 不明なタイプ
  }
}
